import { makeStyles } from '@material-ui/core/styles'
import { calcMargin } from '@v4/utils/theme'

const useStyles = makeStyles(
	theme => ({
		root: {
			marginLeft: theme.spacing(-2),
			marginRight: theme.spacing(-2),
			[theme.breakpoints.up('sm')]: {
				marginLeft: theme.spacing(-3),
				marginRight: theme.spacing(-3),
				marginTop: ({ metaData, isMobile, minMargins }) => {
					if (!isMobile) {
						return null
					}

					const marginMeta = metaData.overrideXsMargins?.toBoolean()
						? metaData.xsMarginTop
						: metaData.marginTop

					return calcMargin({
						spacing: theme.spacing,
						value: marginMeta?.metaValue,
						minMargin: minMargins.top,
						isMobile: true,
						negative: true,
					})
				},
				marginBottom: ({ metaData, minMargins, isMobile }) => {
					if (!isMobile) {
						return null
					}
					const marginMeta = metaData.overrideXsMargins?.toBoolean()
						? metaData.xsMarginBottom
						: metaData.marginBottom

					return calcMargin({
						spacing: theme.spacing,
						value: marginMeta?.metaValue,
						minMargin: minMargins.bottom,
						isMobile: true,
						negative: true,
					})
				},
			},
		},
	}),
	{ name: 'CallToAction-Cta10_11' },
)

export default useStyles
